import Vue from 'vue'
if (['local_dev', 'development', 'staging'].includes(process.env.VUE_APP_ENVIRONMENT)) {
  Vue.config.devtools = true
  Vue.config.productionTip = false
} else if (['production'].includes(process.env.VUE_APP_ENVIRONMENT)) {
  Vue.config.devtools = false
  Vue.config.productionTip = false
  Vue.config.silent = false
}
// import VueIntercom from 'vue-intercom'
// Vue.use(VueIntercom, {appId: process.env.VUE_APP_INTERCOM_APP_ID})
import { sentry } from '@/globals'
import App from './App'
import router from './router'
import store from '@/store'
import langs from './langs'
import UserService from './service/user'
import cart from './cart'
import Validator from './service/Validator'
// import * as VueGoogleMaps from 'vue2-google-maps'
import numeral from 'numeral'
console.log('v:', process.env.VUE_APP_VERSION)

import { log } from '@/service/log'
Vue.prototype.$log = log

window.Vue = Vue
cart.loadGoogleApi()

import validationLocaleCs from "./langs/validation.cs";

Validator.localize('cs', validationLocaleCs)
Validator.setLocale('cs')

Vue.directive('localize', {
  bind: function(el, binding) {
    if (binding.value.fill) {
      let html = langs.get(binding.value.key)
      for (let i = 0; i < binding.value.fill.length; i++) {
        html = html.replace('%' + i, binding.value.fill[i])
      }
      el.innerHTML = html
    } else {
      el.innerHTML = langs.get(binding.value.key)
    }
  }
})
Vue.directive('verify', {
  bind: (el, binding) => {
    Validator.add({
      input: el,
      test: binding.value
    })
  },
  unbind: (el) => {
    Validator.remove({
      input: el
    })
  }
})

// numeral.js formatter
Vue.filter("formatNumber", function(value) {
  numeral.localeData().delimiters.thousands = ' ';
  return numeral(value).format("0,0");
})
Vue.filter("formatPrice", function(value) {
  numeral.localeData().delimiters.thousands = ' ';
  return `${numeral(value).format("0,0")} Kč`;
})

Date.prototype.addDays = function(days) {
  let d = new Date(this.getTime())
  d.setDate(d.getDate() + parseInt(days))
  return d
}
Date.prototype.addMinutes = function(minutes) {
  let d = new Date(this.getTime())
  d.setMinutes(d.getMinutes() + parseInt(minutes))
  return d
}
Date.prototype.addSeconds = function(seconds) {
  let d = new Date(this.getTime())
  d.setSeconds(d.getSeconds() + parseInt(seconds))
  return d
}
Date.prototype.yyyymmdd = function() {
  var mm = this.getMonth() + 1
  var dd = this.getDate()

  return [this.getFullYear(),
    (mm > 9 ? '' : '0') + mm,
    (dd > 9 ? '' : '0') + dd
  ].join('')
}

Date.prototype.fromYyyymmdd = function(ymd) {
  if (ymd && ymd.length >= 8)
    this.setFullYear(ymd.substring(0, 4))
  this.setMonth((ymd.substring(4, 6) * 1) - 1)
  this.setDate(ymd.substring(6, 8))
  return this
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
